import registrationInstance from '../instance'

const updateExpertCartSettings = (data) => {
	return registrationInstance.put('/company/expert/cartSettings', data)
}

export default updateExpertCartSettings
